import { render, staticRenderFns } from "./Hallitus.vue?vue&type=template&id=3157345c&scoped=true"
var script = {}
import style0 from "./Hallitus.vue?vue&type=style&index=0&id=3157345c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157345c",
  null
  
)

export default component.exports